import type {SearchType} from '../rules/constants';
import {isSearchTypeSortable} from './isSearchTypeSortable';

/**
 * Check if search types are sortable (on the server)
 * @param searchTypes
 * @returns Search types are sortable
 */
export const areSearchTypesSortable = (searchTypes: SearchType[]) =>
	!searchTypes.some((searchType) => !isSearchTypeSortable(searchType));

export default areSearchTypesSortable;
